import { createFileRoute } from "@tanstack/react-router";
import { OrganizacionManualPage } from "@/features/organizacion-manual/components/OrganizacionManualPage";
import { misOrganizacionesQueryOptions } from "@/features/organizacion-manual/hooks/use-mis-organizaciones";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/organizacion-manual` · P44 FB60 Contrapago · paso
 * previo a Datos Generales (reemplaza la carga de CFDI, que aquí no existe).
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/organizacion-manual")({
  loader: ({ context: { queryClient }, params: { id } }) => Promise.all([queryClient.ensureQueryData(solicitudQueryOptions(id)), queryClient.ensureQueryData(misOrganizacionesQueryOptions())]),
  component: OrganizacionManualPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
